import { inject, Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { DialogService } from './dialog.service';
import { ConfirmDialog } from '../common/interfaces/confirm-dialog.interface';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {
    private clipboard = inject(Clipboard);
    private dialogService = inject(DialogService);

    public async easyCopyToClipboard(data: string): Promise<boolean> {
        return this.clipboard.copy(data);

    }

    public async copyToClipboard(data: string): Promise<void> {
        const copySuccessfull = this.clipboard.copy(data);

        if (copySuccessfull) {
            await this.showConfirmDialog();
        } else {
            try {
                const clipboardPermission = await navigator.permissions.query({ name: 'clipboard-read' as PermissionName });

                if (clipboardPermission.state === 'denied') {
                    await this.showMissingPermissionDialog();

                    return;
                }

                await navigator.clipboard.writeText(data);

                await this.showConfirmDialog();
                return;
            } catch {
                await this.showMissingPermissionDialog();
                return;
            }
        }
    }

    private async showConfirmDialog(): Promise<boolean> {
        const dialogData: ConfirmDialog = {
            headerText: 'Copied to clipboard',
            dialogText: 'The data has been copied to your clipboard. Please open a Miro Board and press "Ctrl+V" to insert as notes.',
            submitText: 'Ok',
        };

        return await lastValueFrom(
            this.dialogService.openConfirmationDialog$(dialogData),
        );
    }

    private async showMissingPermissionDialog(): Promise<boolean> {
        const dialogData: ConfirmDialog = {
            headerText: 'Missing permission',
            dialogText: 'Please allow clipboard access for this website through your browser settings',
            submitText: 'Ok',
        };

        return await lastValueFrom(
            this.dialogService.openConfirmationDialog$(dialogData),
        );
    }
}

